// extracted by mini-css-extract-plugin
export default {"img_container":"Carousel_img_container__kgwd6","bordered":"Carousel_bordered__8Nc1s"};